module.exports = __webpack_public_path__ + "src/assets/img/logo-white.f753df0d.svg";